module.exports = __webpack_public_path__ + "static/media/step-3.ba3d8a5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/how-it-works/stepper-how-it-works/step-3.png
// module id = 2212
// module chunks = 0